import type { SKUSelectionFooterProps } from '@src/components/SKUSelectionFooter/SKUSelectionFooter.props'

export const SKUSelectionFooterDefaults: SKUSelectionFooterProps = {
  buttonCopy: 'Add to Cart',
  heading: 'Customize Bundle',
  invalidStateMessage: 'Make all selections to add to cart',
  redirectUrl: '/cart',
  extraSkus: [{ sku: 'BBBODINT40' }],
}
